import React, { FC, ReactNode } from "react";
import { TThemeVariant, useTheme } from "../../Utility/ThemeProvider";
import ContentContext, { DEFAULT_CONTENT_CONTEXT } from "./ContentContext";

export interface IContentProps {
  /** Raw HTML that will be passed to the content block */
  data?: string;
  /** Override theme for current case */
  variant?: TThemeVariant;
  /** Passes children when there is no 'data' passed in */
  children?: ReactNode;
}

/** An article / WYSIWYG content component <br/>
 *  In a dark theme adds css variables for inner elements / custom Content Widgets.
 * */
const Content: FC<IContentProps> = ({ data, variant, children }) => {
  const theme = useTheme(variant);
  return (
    <ContentContext.Provider value={DEFAULT_CONTENT_CONTEXT}>
      <div
        className={`content ${theme === "dark" ? "content--theme-dark" : ""}`}
        dangerouslySetInnerHTML={data ? { __html: data } : undefined}
        data-testid="Content"
      >
        {data ? null : children}
      </div>
    </ContentContext.Provider>
  );
};

export default Content;
